import { makeStyles } from '@material-ui/styles'
import { ChevronRightRounded } from '@mui/icons-material'
import { Breadcrumbs, Link, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { Link as RRDLink } from 'react-router-dom'

export default function Header() {

    const classes = useStyles()

    return(

        <Stack direction="row" justifyContent="space-between" alignItems="center" >
                
            <Stack direction="column">
                <Typography variant="h6" sx={{color: "grey.200", fontWeight: "bold" }}>General Settings</Typography>
                <Breadcrumbs sx={{color: grey[500] }} separator={<ChevronRightRounded sx={{color: grey[500]}}  />}  >
                    <Link to="" className={classes.links} component={RRDLink} >
                        Settings
                    </Link>
                    <Link to="" className={classes.link_current} component={RRDLink} >
                        General Settings
                    </Link>
                </Breadcrumbs>
            </Stack>

        </Stack>

    )
}

const useStyles= makeStyles(theme=>({

    links:{
        color: grey[200],
        textDecoration: "none",
        fontSize: "13px"
    },
    link_current:{
        color: grey[500],
        textDecoration: "none",
        fontSize: "13px"
    }

}))
